import axios from 'axios';

export default {
    exportTestas(orderLineIds) {
        return axios.post('/orderline/exportTestas/', { orderLineIds });
    },
    orderTestas(orderLineIds) {
        return axios.post('/orderline/orderTestas/', { orderLineIds });
    },
    createOrderline(payload) {
        return axios.post('/orderline/createOrderline/', payload);
    },
    generateOrderlines() {
        return axios.post('/orderline/generateOrderlines/');
    },
    remove(orderlineId) {
        return axios.post('/orderline/remove/', { orderlineId });
    },
    setStatusOrdered(orderlineId) {
        return axios.post('/orderline/setStatusOrdered/', { orderlineId });
    },
    list(payload) {
        return axios.post('/orderline/list/', payload);
    },
    updateDateOrdered(orderlineId, dateOrdered) {
        return axios.post('/orderline/updateDateOrdered/', {
            orderlineId,
            dateOrdered,
        });
    },
    updateDeliveryDate(orderlineId, deliveryDate) {
        return axios.post('/orderline/updateDeliveryDate/', {
            orderlineId,
            deliveryDate,
        });
    },
    update(
        orderlineId,
        amount,
        amountOrdered,
        comments,
        status,
        destinationStock = 'current'
    ) {
        return axios.post('/orderline/update/', {
            orderlineId,
            amount,
            amountOrdered,
            comments,
            status,
            destinationStock,
        });
    },
    details(orderlineId) {
        return axios.post('/orderline/details/', { orderlineId });
    },
};
